// Module
var code = "<div class=\"company-name\" id=\"btn-company-name\" :class=\"{'can-click': user?.契約会社属性 == 5}\" @click=\"() => { showModal = user?.契約会社属性 == 5; }\">{{companyName}}</div> <change-company v-model=\"showModal\" v-if=\"user?.契約会社属性 == 5\"/> ";
// Exports
export default code;